import { StyledRSelect } from "./Select.components";

export type Option = { label: string; value: string };

interface Props {
  label?: string;
  aria: string;
  onChange: (option: Option) => void;
  onBlur: () => void;
  options: Option[];
  selected: boolean;
  defaultValue?: Option;
  value?: Option;
  isLoading?: boolean;
}

const Select: React.FunctionComponent<Props> = ({
  label,
  aria,
  onChange,
  onBlur,
  selected,
  options,
  value,
  defaultValue,
  isLoading,
}) => {
  return (
    <div>
      <label>{label}</label>
      <StyledRSelect
        aria-label={aria}
        onChange={onChange}
        onBlur={onBlur}
        selected={selected}
        value={value}
        options={options}
        isSearchable={false}
        classNamePrefix="react-select"
        defaultValue={defaultValue}
        isLoading={isLoading}
      />
    </div>
  );
};

export default Select;
